import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
const VerifiedApInvoices = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-3">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Verified AP Invoices
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mt-0 mb-3">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>

                  <div class="selecters col-lg-5 col-md-6 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col-12 col-lg-5 px-1">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Status</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div className="shadowclass mt-0">
                  <div className="table-responsive general-setting saved_order_ms">
                    <div className="orderList">
                      <table className="checklist-table remove-space">
                        <thead>
                          <tr>
                            <th> ID </th>
                            <th className="min-wd-200">Payee</th>
                            <th> Status </th>
                            <th>Total</th>
                            <th class="contact-th">Contact</th>
                            <th className="min-wd-150">Created</th>
                            <th className="min-wd-150">Updated</th>
                            <th> Actions </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="order_row">
                            <td> AP0000006 </td>
                            <td>
                              <b>A New Payee Name</b>
                              <br />
                              ID #454543435 (2022-05-12)
                            </td>
                            <td>
                              <span class="green_tag"> Verified </span>
                            </td>
                            <td> $220.00 </td>
                            <td class="contact-td">
                              ankita.bhatt@xicom.biz;sandeep@xicom.biz
                            </td>
                            <td> May 12, 2022 </td>
                            <td> May 12, 2022 </td>
                            <td>
                              <div className="d-flex">
                                <a
                                  class="circle_icon"
                                  title="View"
                                  href="/ap_invoices/view/2196"
                                >
                                  <i class="iconSprites eye-icon"></i>
                                </a>
                                <a
                                  class="circle_icon red cancel_invoice"
                                  val="2196"
                                  title="Cancel"
                                  href="javascript:void(0)"
                                >
                                  <i class="iconSprites cancel-icon"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default VerifiedApInvoices;
